import apiClient from "./client";
import type {
  ApiResponse,
  LoginResult,
  AdminUser,
  ChangePasswordRequest,
} from "@/types";

export interface LoginData {
  username: string;
  password: string;
}

export async function login(
  data: LoginData,
): Promise<ApiResponse<LoginResult>> {
  const { data: res } = await apiClient.post("/auth/login", data);
  return res;
}

export async function getProfile(): Promise<ApiResponse<AdminUser>> {
  const { data } = await apiClient.get("/auth/profile");
  return data;
}

export async function changePassword(
  data: ChangePasswordRequest,
): Promise<ApiResponse<null>> {
  const { data: res } = await apiClient.put("/auth/password", data);
  return res;
}

export async function updateIPWhitelist(
  loginIPRange: string,
): Promise<ApiResponse<{ login_ip_range: string }>> {
  const { data } = await apiClient.put("/auth/ip-whitelist", {
    login_ip_range: loginIPRange,
  });
  return data;
}

export async function logout(): Promise<ApiResponse<null>> {
  const { data } = await apiClient.post("/auth/logout");
  return data;
}
